import { useToast } from '@caruso/ui';

export function useQuickSaleLink() {
  const { toast } = useToast();

  const generateQuickSaleLink = (clientId: string, productId: string) => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/venda-rapida/${clientId}/${productId}`;
  };

  const copyQuickSaleLink = async (clientId: string, productId: string) => {
    const link = generateQuickSaleLink(clientId, productId);

    try {
      await navigator.clipboard.writeText(link);
      toast({
        title: 'Link copiado!',
        description: 'O link de venda rápida foi copiado para a área de transferência',
        variant: 'success',
      });
      return link;
    } catch (error) {
      toast({
        title: 'Erro ao copiar link',
        description: 'Não foi possível copiar o link. Tente novamente.',
        variant: 'destructive',
      });
      return null;
    }
  };

  const shareQuickSaleLink = (clientId: string, productId: string, clientName: string, productName: string) => {
    const link = generateQuickSaleLink(clientId, productId);
    const message = `Olá ${clientName}! Aqui está o link para finalizar sua compra do produto ${productName}: ${link}`;

    // Abrir WhatsApp Web com a mensagem
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');

    return link;
  };

  return {
    generateQuickSaleLink,
    copyQuickSaleLink,
    shareQuickSaleLink,
  };
}
